import React, { useState } from 'react';
import {
    Box, Typography, Card, CardContent, Grid, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Button, Chip,
    TextField, Tabs, Tab, InputAdornment, Avatar, Dialog,
    DialogTitle, DialogContent, DialogActions, MenuItem
} from '@mui/material';
import {
    Search as SearchIcon, Download as DownloadIcon,
    PersonAdd as PersonAddIcon, Login as CheckInIcon, Logout as CheckOutIcon,
    Badge as BadgeIcon, Print as PrintIcon
} from '@mui/icons-material';
import { toast } from 'react-toastify';

const VisitorManagement = () => {
    const [tab, setTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [formData, setFormData] = useState({ name: '', phone: '', purpose: '', meetingWith: '', idType: '', idNumber: '', company: '' });

    const visitors = [
        { id: 1, name: 'Mr. Rajesh Patil', phone: '9876543210', purpose: 'Parent Meeting', meetingWith: 'Class Teacher - Mrs. Sharma', company: '-', idType: 'Aadhaar', idNumber: '****9012', checkIn: '09:30 AM', checkOut: '10:15 AM', date: '2026-02-15', status: 'Checked Out', badge: 'V001' },
        { id: 2, name: 'Ms. Anjali Desai', phone: '9876543211', purpose: 'Fee Enquiry', meetingWith: 'Office - Mr. Joshi', company: '-', idType: 'Driving License', idNumber: '****3456', checkIn: '10:00 AM', checkOut: '-', date: '2026-02-15', status: 'Inside', badge: 'V002' },
        { id: 3, name: 'Mr. Sunil Mehta', phone: '9876543212', purpose: 'Book Delivery', meetingWith: 'Librarian', company: 'ABC Publishers', idType: 'PAN Card', idNumber: '****7890', checkIn: '11:00 AM', checkOut: '11:45 AM', date: '2026-02-15', status: 'Checked Out', badge: 'V003' },
        { id: 4, name: 'Dr. Kavita Wagh', phone: '9876543213', purpose: 'Health Checkup', meetingWith: 'Principal', company: 'City Hospital', idType: 'Doctor ID', idNumber: '****1234', checkIn: '02:00 PM', checkOut: '-', date: '2026-02-15', status: 'Inside', badge: 'V004' },
        { id: 5, name: 'Mr. Anil Kumar', phone: '9876543214', purpose: 'Stationery Delivery', meetingWith: 'Admin Office', company: 'Kumar Stationers', idType: 'Aadhaar', idNumber: '****5678', checkIn: '08:30 AM', checkOut: '09:00 AM', date: '2026-02-14', status: 'Checked Out', badge: 'V005' },
    ];

    const filteredVisitors = visitors.filter(v => {
        const matchTab = tab === 0 ? true : tab === 1 ? v.status === 'Inside' : v.status === 'Checked Out';
        const matchSearch = !searchTerm || v.name.toLowerCase().includes(searchTerm.toLowerCase()) || v.purpose.toLowerCase().includes(searchTerm.toLowerCase());
        return matchTab && matchSearch;
    });

    const insideCount = visitors.filter(v => v.status === 'Inside').length;
    const todayCount = visitors.filter(v => v.date === '2026-02-15').length;

    const handleCheckOut = (id) => {
        toast.success('Visitor checked out successfully');
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" fontWeight={700}>Visitor Management</Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant="contained" startIcon={<PersonAddIcon />} size="small" onClick={() => setOpenDialog(true)}>New Visitor</Button>
                    <Button variant="outlined" startIcon={<PrintIcon />} size="small">Print Log</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} size="small">Export</Button>
                </Box>
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #1a9e8f' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Total Today</Typography>
                            <Typography variant="h4" fontWeight={700}>{todayCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #4caf50' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <CheckInIcon sx={{ color: '#4caf50', fontSize: 22 }} />
                            <Typography variant="body2" color="text.secondary">Currently Inside</Typography>
                            <Typography variant="h4" fontWeight={700} color="success.main">{insideCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #2196f3' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <CheckOutIcon sx={{ color: '#2196f3', fontSize: 22 }} />
                            <Typography variant="body2" color="text.secondary">Checked Out</Typography>
                            <Typography variant="h4" fontWeight={700}>{todayCount - insideCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #ff9800' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <BadgeIcon sx={{ color: '#ff9800', fontSize: 22 }} />
                            <Typography variant="body2" color="text.secondary">Active Badges</Typography>
                            <Typography variant="h4" fontWeight={700}>{insideCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Card>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                    <Tab label={`All (${visitors.length})`} />
                    <Tab label={`Inside (${insideCount})`} />
                    <Tab label={`Checked Out (${visitors.length - insideCount})`} />
                </Tabs>
                <Box sx={{ p: 2 }}>
                    <TextField fullWidth size="small" placeholder="Search by name or purpose..." value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} sx={{ mb: 2 }}
                        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />

                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 700 }}>Badge</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Visitor</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Phone</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Purpose</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Meeting With</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Check In</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Check Out</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredVisitors.map(v => (
                                    <TableRow key={v.id} hover sx={{ bgcolor: v.status === 'Inside' ? '#e8f5e9' : 'inherit' }}>
                                        <TableCell><Chip label={v.badge} size="small" color="primary" variant="outlined" /></TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Avatar sx={{ width: 28, height: 28, fontSize: 11, bgcolor: '#1a9e8f' }}>{v.name[0]}</Avatar>
                                                <Box>
                                                    <Typography variant="body2" fontWeight={600}>{v.name}</Typography>
                                                    {v.company !== '-' && <Typography variant="caption" color="text.secondary">{v.company}</Typography>}
                                                </Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell>{v.phone}</TableCell>
                                        <TableCell>{v.purpose}</TableCell>
                                        <TableCell>{v.meetingWith}</TableCell>
                                        <TableCell><Typography variant="caption">{v.idType} ({v.idNumber})</Typography></TableCell>
                                        <TableCell>{v.checkIn}</TableCell>
                                        <TableCell>{v.checkOut}</TableCell>
                                        <TableCell>
                                            <Chip size="small" label={v.status} color={v.status === 'Inside' ? 'success' : 'default'}
                                                icon={v.status === 'Inside' ? <CheckInIcon fontSize="small" /> : <CheckOutIcon fontSize="small" />} />
                                        </TableCell>
                                        <TableCell>
                                            {v.status === 'Inside' && (
                                                <Button variant="outlined" size="small" color="error" startIcon={<CheckOutIcon />}
                                                    onClick={() => handleCheckOut(v.id)}>Out</Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Card>

            {/* New Visitor Dialog */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Register New Visitor</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField label="Visitor Name" fullWidth value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                        <TextField label="Phone Number" fullWidth value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                        <TextField label="Company/Organization" fullWidth value={formData.company} onChange={(e) => setFormData({ ...formData, company: e.target.value })} />
                        <TextField select label="Purpose of Visit" fullWidth value={formData.purpose} onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}>
                            {['Parent Meeting', 'Fee Enquiry', 'Admission Enquiry', 'Delivery', 'Official Visit', 'Health Checkup', 'Other'].map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
                        </TextField>
                        <TextField label="Meeting With" fullWidth value={formData.meetingWith} onChange={(e) => setFormData({ ...formData, meetingWith: e.target.value })} />
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField select fullWidth label="ID Type" value={formData.idType} onChange={(e) => setFormData({ ...formData, idType: e.target.value })}>
                                    {['Aadhaar', 'PAN Card', 'Driving License', 'Voter ID', 'Passport', 'Other'].map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField label="ID Number" fullWidth value={formData.idNumber} onChange={(e) => setFormData({ ...formData, idNumber: e.target.value })} />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button variant="contained" startIcon={<CheckInIcon />} onClick={() => { toast.success('Visitor checked in'); setOpenDialog(false); }}>Check In</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default VisitorManagement;
